define(["require", "exports", "../domutils", "./StyleTool", "nanopop", "../utils/utils"], function (require, exports, domutils_1, StyleTool_1, nanopop_1, utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.OptionsStyleTool = void 0;
    class OptionsStyleTool extends StyleTool_1.StyleTool {
        constructor(viewer, id, defaultValue, changeHandler, options) {
            super(viewer, id, defaultValue, changeHandler);
            this.isShown = false;
            this.clickAwayListener = (e) => {
                if (this.isShown &&
                    !utils_1.eventPath(e).some((el) => el === this.poppedOptions || el === this.btnElement)) {
                    this.hide();
                }
            };
            this.toggle = (show) => {
                show ? this.show() : this.hide();
            };
            this.show = () => {
                var _a;
                if (this.poppedOptions) {
                    domutils_1.addClass(this.poppedOptions, 'visible');
                }
                this.isShown = true;
                (_a = this.popper) === null || _a === void 0 ? void 0 : _a.update();
            };
            this.hide = () => {
                var _a;
                if (this.poppedOptions) {
                    domutils_1.removeClass(this.poppedOptions, 'visible');
                }
                this.isShown = false;
                (_a = this.popper) === null || _a === void 0 ? void 0 : _a.update();
            };
            this.syncValue = (val, text) => {
                if (val) {
                    this.changeHandler(val);
                    if (this.btn) {
                        this.btn.textContent = text;
                    }
                }
            };
            this.options = options;
            // must be called
            this.initTool();
        }
        initTool() {
            this.btn = document.createElement('div');
            domutils_1.addClass(this.btn, 'selected-option');
            this.btn.textContent = this.defaultValue;
            this.poppedOptions = this.initOptions();
            this.popper = nanopop_1.createPopper(this.btn, this.poppedOptions, {
                margin: 10,
            });
            this.hide();
            utils_1.on(this.btn, ['mousedown', 'touchstart'], () => {
                this.toggle(!this.isShown);
            }, {
                capture: true,
            });
            utils_1.on(document, ['mousedown', 'touchstart'], this.clickAwayListener, {
                capture: true,
            });
            // this.selectBox = document.createElement('select');
            // addClass(this.selectBox, 'option-select');
            // Object.keys(this.options).forEach((key) => {
            //     const option = document.createElement('option');
            //     option.value = key;
            //     option.text = this.options[key];
            //     this.selectBox?.appendChild(option);
            // });
            // if (this.defaultValue) {
            //     this.selectBox.value = this.defaultValue;
            // }
            // this.selectBox.addEventListener('change', this.syncValue);
        }
        initOptions() {
            const options = document.createElement('div');
            domutils_1.addClass(options, 'options-select');
            document.body.appendChild(options);
            Object.keys(this.options).forEach((key) => {
                const option = document.createElement('div');
                domutils_1.addClass(option, 'option');
                option.textContent = this.options[key];
                options.appendChild(option);
                utils_1.on(option, ['mousedown', 'touchstart'], () => {
                    this.syncValue(key, this.options[key]);
                }, {
                    capture: true,
                });
            });
            return options;
        }
        getTool() {
            return this.btn;
        }
    }
    exports.OptionsStyleTool = OptionsStyleTool;
});
//# sourceMappingURL=OptionsStyleTool.js.map